import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { GenericModalComponent } from '@app/helpers/generic-modal-component';
import { ConstantsService } from '@app/services/constants.service';
import { EmployeeService } from '@app/services/employee.service';
import { UserService } from '@app/services/user.service';
import { environment } from '@env/environment';
import { Select2OptionData } from 'ng-select2';

declare const fbq: any;
declare const gtag: Function;

@Component({
  selector: 'app-resume-send-modal',
  templateUrl: './resume-send-modal.component.html',
  styleUrls: ['./resume-send-modal.component.css']
})
export class ResumeSendModalComponent extends GenericModalComponent implements OnInit {

  @Output() eventResumeSend = new EventEmitter<any>();

  public isBulkMode: boolean = false;

  //bulk action
  public employerList: Array<number> = [];
  public employerListName: Array<string> = [];

  //individual action
  public idInstitution: number = 0;
  public institutionName: string = "";
  public isMultiAddress: boolean = false;

  public isValidProfile: boolean = undefined;
  private sendResumeInProgress: boolean = false;
  public creditDaily: number = 10;
  public balance: number = 0;
  public creditRequired: number = 1;

  public modalTitle = "Enviar CV";

  public dataSelectAddress: Array<Select2OptionData> = []

  constructor(public constantsService: ConstantsService, private employeeService: EmployeeService, private userService: UserService) {
    super('modal-send-cv-one-headquarters', "form-carousel-send-cv");
    this.createFormGroup();
  }

  createFormGroup() {
    this._formGroupModal = new UntypedFormGroup({ institutionAddress: new UntypedFormControl([]) });
  }

  ngOnInit(): void {
    this.helpService.getScriptJs();

  }

  setBulkMode(employerList: Array<number>, employerListName: Array<string>) {
    this.isBulkMode = true;
    this.resetStepCarousel();
    this.idInstitution = 0;
    this.institutionName = "";
    this.isMultiAddress = false;
    this.employerList = employerList;
    this.employerListName = employerListName;
    this.validateEmployeeProfileAndCredit();
  }

  setIndividualMode(idInstitution: number, institutionName: string, institutionAddressList: Array<any>) {
    this.isBulkMode = false;
    this.idInstitution = idInstitution;
    this.institutionName = institutionName;
    this.isMultiAddress = institutionAddressList.length > 1 ? true : false;

    this.dataSelectAddress = [];
    institutionAddressList.forEach((e: any) => { this.dataSelectAddress = [...this.dataSelectAddress, { id: e.institutionAddress, text: e.institutionAddress }]; });

    this.employerList = [];
    this.employerListName = [];
    this.resetStepCarousel();
    this.validateEmployeeProfileAndCredit();
  }

  validateEmployeeProfileAndCredit() {

    this.isValidProfile = undefined;
    this.modalTitle = "Enviar CV";

    this.institutionAddress.setValue([]);

    this.employeeService.getValidationResume(this.userService.getIdEmployee()).toPromise().then(res => {

      if (res.code === 0) {

        this.isValidProfile = res.employeeProfileValid === 1 ? true : false;
        this.creditDaily = res.credit;
        var creditRequired = this.isBulkMode === false ? 1 : this.employerList.length;
        this.balance = parseInt(res.balance) - creditRequired;

        if ((this.balance) < 0) {
          this.modalTitle = "Límite diario de envíos alcanzado";
        }

        if (this.isMultiAddress === true) {
          this.institutionAddress.setValidators([Validators.required]);
        }
        else {
          this.institutionAddress.clearValidators();
        }

        this.institutionAddress.updateValueAndValidity();
        this.institutionAddress.markAsUntouched();

      }
      else {
        this.isValidProfile = false;
      }
    }, () => { this.isValidProfile = false; })
  }

  sendResume(event) {
    event.preventDefault();

    if (this.sendResumeInProgress === true) { return; }

    let req = {
      _idEmployee: this.userService.getIdEmployee(),
      institutionList: this.isBulkMode === true ? this.employerList : [this.idInstitution],
      addressList: this.institutionAddress.value
    };

    this.employeeService.sendResume(req).toPromise().then(res => {

      switch (res.status_code) {

        case 0:
          if (this.isBulkMode === true) { this.eventResumeSend.next({ action: "clear_bulk_options_event" }) } else { this.eventResumeSend.next({ action: "update_search", _idInstitution: this.idInstitution }) }

          this.showStepSuccess();

          if (environment.production === true) {
            gtag('event', 'Teacher Resume Sent', { 'event_category': 'Form Submit', 'event_label': 'Completed' });
            fbq('track', 'TeacherResumeSent');
          }

          break;

        case 2:
          this.showStepError();
          break;

        default:
          this.showStepError();
          break;
      }

      this.sendResumeInProgress = false;

    },
      err => {
        console.error(err);
        this.showStepError();
        this.sendResumeInProgress = false;
      }
    )
  }

  eventFormProfile(event: string) {
    switch (event) {
      case "event_success_form_employer":
        this.isValidProfile = true;
        this.resetStepCarousel()
        break;
    }

  }

  get institutionAddress() { return this._formGroupModal.get('institutionAddress') as UntypedFormControl };
}
